import { useMemo } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import { isWidgetMenuAction } from "views/components/widgets/Types";
const useWidgetExportActionComponent = (widget) => {
  var _a;
  const exportActions = usePluginEntities("views.widgets.exportAction");
  const widgetExportAction = useMemo(
    () => exportActions == null ? void 0 : exportActions.filter(
      ({ action, useCondition }) => typeof useCondition === "function" && // eslint-disable-next-line react-hooks/rules-of-hooks
      useCondition() && action && (typeof action.isHidden !== "function" || !action.isHidden(widget))
    ).map(({ action }) => action).filter(isWidgetMenuAction),
    [exportActions, widget]
  );
  return (_a = widgetExportAction == null ? void 0 : widgetExportAction[0]) == null ? void 0 : _a.component;
};
export default useWidgetExportActionComponent;
